// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fqlk","field":"styles_field__1q92n","fieldCol":"styles_fieldCol__V4RpJ","diffCol":"styles_diffCol__7X4ko","diff":"styles_diff__1NqFp"};